import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu, MenuItem } from '@mui/material';

import {
  LOCALE_LABELS,
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from '../../../constants/locales';
import { syncNotificationLanguage } from '../../../common/utils/syncNotificationLanguage';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (locale: SupportedLocale) => {
    localStorage.setItem('LANGUAGE', locale);
    i18n.changeLanguage(locale);
    syncNotificationLanguage(locale);
    handleClose();
  };

  const currentLabel = LOCALE_LABELS[i18n.language] ?? LOCALE_LABELS[SUPPORTED_LOCALES[0]];

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="outlined"
        size="small"
        startIcon={<span className="material-symbols-outlined" style={{ fontSize: 18 }}>language</span>}
        sx={{
          color: '#374151',
          borderColor: '#e5e7eb',
          textTransform: 'none',
          fontWeight: 500,
          minWidth: 0,
          padding: '4px 10px',
        }}
      >
        {currentLabel}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {SUPPORTED_LOCALES.map((locale) => (
          <MenuItem
            key={locale}
            selected={locale === i18n.language}
            onClick={() => handleSelect(locale)}
          >
            {LOCALE_LABELS[locale]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
